export default {
    props : {
        value : {
            type : String,
            required : false,
        },
        showMore : {
            type : Boolean,
            required : false,
        },
    },
    data () {
        return {
            limit : 2,
            localShowMore : false,
            parsedValues : [],
        };
    },
    computed : {
        showButton () {
            return this.parsedValues.length > this.limit
        },
        isShowMore () {
            return this.showMore || this.localShowMore;
        },
        listOfValues () {
            if(this.isShowMore){
                return this.parsedValues;
            }
            return this.parsedValues.slice(0, this.limit);
        },
        buttonLabel () {
            return this.isShowMore ? "Show Less" : `Show ${this.parsedValues.length - this.limit} More`;
        },
    },
    methods : {
        toggleShowMore (event) {
            event.stopPropagation();
            this.localShowMore = !this.localShowMore;
        },
    },
};
